var map = {
	"./de.json": 9464,
	"./en.json": 4510,
	"./en_GB.json": 2635,
	"./en_dev.json": 9672,
	"./es.json": 8901,
	"./fr.json": 119,
	"./it.json": 7640,
	"./pl.json": 7958,
	"./pt.json": 6571,
	"./sv.json": 8537,
	"./uk.json": 5954,
	"src/viewLayer/assets/locales/de.json": 9464,
	"src/viewLayer/assets/locales/en.json": 4510,
	"src/viewLayer/assets/locales/en_GB.json": 2635,
	"src/viewLayer/assets/locales/en_dev.json": 9672,
	"src/viewLayer/assets/locales/es.json": 8901,
	"src/viewLayer/assets/locales/fr.json": 119,
	"src/viewLayer/assets/locales/it.json": 7640,
	"src/viewLayer/assets/locales/pl.json": 7958,
	"src/viewLayer/assets/locales/pt.json": 6571,
	"src/viewLayer/assets/locales/sv.json": 8537,
	"src/viewLayer/assets/locales/uk.json": 5954
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9694;